import { ChannelsNames } from '../Channels';
// Constants
import { CHANNEL_CONNECTION_WHATSAPP_ACTIVATION_FLOW_STARTED, CHANNEL_CONNECTION_WHATSAPP_ACTIVATION_FLOW_PHONE_NOT_FOUND, CHANNEL_CONNECTION_WHATSAPP_ACTIVATION_FLOW_SELECTED_PHONE, CHANNEL_CONNECTION_WHATSAPP_ACTIVATION_FLOW_PHONE_NOT_FOUND_OPEN_EMBED_SIGNUP, CHANNEL_CONNECTION_WHATSAPP_ACTIVATION_FLOW_SELECTED_PHONE_OPEN_EMBED_SIGNUP, CHANNEL_CONNECTION_WHATSAPP_ACTIVATION_FLOW_ACTIVATE_NUMBER, CHANNEL_CONFIGURATION_WHATSAPP_TAB_ITEM_CONFIGURATIONS_CLICKED, CHANNEL_CONFIGURATION_WHATSAPP_QUICK_REPLY_SWITCH_CLICKED, CHANNEL_CONFIGURATION_WHATSAPP_QUICK_REPLY_DOCUMENTATION_CLICKED, CHANNEL_CONFIGURATION_WHATSAPP_MENU_SWITCH_CLICKED, CHANNEL_CONFIGURATION_WHATSAPP_MENU_DOCUMENTATION_CLICKED, CHANNEL_CONNECTION_WHATSAPP_DOCUMENTATION_LINK_CLICKED, CHANNEL_CONNECTION_WHATSAPP_ACTIVATION_BACK_BUTTON_CLICKED, CHANNEL_CONNECTION_WHATSAPP_ACTIVATION_FLOW_EMBEDDED, CHANNEL_CONNECTION_WHATSAPP_ACTIVATION_FLOW_MODAL_SUCCESS_CLOSED, CHANNEL_CONFIGURATION_WHATSAPP_AUTH_MEDIA_SWITCH_CLICKED, } from '../ChannelsSegmentEvents';
// Styles
import './WhatsApp.scss';
// Controllers
import { ChannelBaseController } from '../ChannelBaseController';
import { ChannelsFeatures } from '../ChannelsFeatures';
// Views
import '!ng-cache-loader!./WhatsAppEmbeddedSignupSteps/WhatsAppNotPossibleToConnectDueNumbersBalance.html';
import '!ng-cache-loader!./WhatsAppEmbeddedSignupSteps/WhatsAppAwaitContainer.html';
import '!ng-cache-loader!./WhatsAppEmbeddedSignupSteps/WhatsAppVerified.html';
import '!ng-cache-loader!./WhatsAppEmbeddedSignupSteps/WhatsAppIcon.html';
import '!ng-cache-loader!./WhatsAppEmbeddedSignupSteps/WhatsAppNumberNotFound.html';
import '!ng-cache-loader!./WhatsAppEmbeddedSignupSteps/WhatsAppSelectedNumber.html';
import '!ng-cache-loader!./WhatsAppEmbeddedSignupSteps/WhatsAppStart.html';
import '!ng-cache-loader!./WhatsAppEmbeddedSignupSteps/WhatsAppCompanyInformation.html';
import '!ng-cache-loader!./WhatsAppEmbeddedSignupSteps/WhatsAppConfiguration.html';
import '!ng-cache-loader!./WhatsAppEmbeddedSignupSteps/WhatsAppFacebookConnectionStep.html';
import '!ng-cache-loader!./WhatsAppEmbeddedSignupSteps/WhatsAppWabaWithActiveNumberInAnotherContract.html';
import { WhatsAppStepsEnum } from './WhatsAppStepsEnum';
import { whatsAppVerticals } from './WhatsAppVerticals';
const bannerIsVisible = 'bannerIsVisible';
const profilePictureMediaTypes = ['jpg', 'jpeg', 'png'];
const languages = { 'pt': 'pt_BR', 'es': 'es_ES', 'en': 'en_US' };
export class WhatsAppController extends ChannelBaseController {
    static $inject = ['$window', 'application', '$scope', '$translate', 'BlipToastService', 'ApplicationService2', 'ChannelsService', 'LoadingService', 'MessagingHubService', 'WhatsAppService', 'AccountService2', '$timeout', 'FacebookLoginPopupService', 'WHATSAPP_AUTH_PERMISSIONS', 'FACEBOOK_POPUP_CONNECTION_TIME', '$cookies', 'TranslateService', 'MEDIA_PROFILE_FOR_AVATARS'];
    constructor($window, application, $scope, $translate, BlipToastService, ApplicationService2, ChannelsService, LoadingService, MessagingHubService, WhatsAppService, AccountService2, $timeout, FacebookLoginPopupService, WHATSAPP_AUTH_PERMISSIONS, FACEBOOK_POPUP_CONNECTION_TIME, $cookies, TranslateService, MEDIA_PROFILE_FOR_AVATARS) {
        'ngInject';
        super(ChannelsNames.WhatsApp, ChannelsService, ApplicationService2, application);
        this.$window = $window;
        this.application = application;
        this.$scope = $scope;
        this.$translate = $translate;
        this.BlipToastService = BlipToastService;
        this.ApplicationService2 = ApplicationService2;
        this.ChannelsService = ChannelsService;
        this.LoadingService = LoadingService;
        this.MessagingHubService = MessagingHubService;
        this.WhatsAppService = WhatsAppService;
        this.AccountService2 = AccountService2;
        this.$timeout = $timeout;
        this.FacebookLoginPopupService = FacebookLoginPopupService;
        this.WHATSAPP_AUTH_PERMISSIONS = WHATSAPP_AUTH_PERMISSIONS;
        this.FACEBOOK_POPUP_CONNECTION_TIME = FACEBOOK_POPUP_CONNECTION_TIME;
        this.$cookies = $cookies;
        this.TranslateService = TranslateService;
        this.MEDIA_PROFILE_FOR_AVATARS = MEDIA_PROFILE_FOR_AVATARS;
        this.whatsAppStepsEnum = WhatsAppStepsEnum;
        this.isPinValid = true;
        this.phoneNumbersForActivation = [];
        this.validations = { isEmailValid: true, isWebsiteValid: true };
        this.loaded = false;
        this.isReplyButtonEnabled = false;
        this.isListMessageEnabled = false;
        this.isCloudApiEnabled = false;
        this.isAuthenticatedMedia = false;
        this.isClosedBanner = false;
        this.isOnPremiseEnabled = false;
        this.showBanner = false;
        this.language = 'pt-BR';
        this.verticalOptions = [];
        this.hasProfileChanges = false;
        this.hasPictureChanges = false;
        this.onChangePhoneNumber = (event) => {
            if (event) {
                this.$timeout(() => {
                    this.phoneNumberSelected = event.detail.value;
                });
            }
        };
        this.onChangePin = (event) => {
            if (!event) {
                return;
            }
            this.$timeout(() => {
                this.isPinValid = false;
            });
            if (event.detail.value.length < 6) {
                return;
            }
            if (/\d{6}$/.test(event.detail.value)) {
                this.$timeout(() => {
                    this.isPinValid = true;
                    this.pinInputed = event.detail.value;
                });
            }
        };
        this.updateDescription = (event) => {
            if (event) {
                this.hasProfileChanges = this.profile.description != event.detail.value;
                this.profile.description = event.detail.value;
            }
        };
        this.updateAddress = (event) => {
            if (event) {
                this.hasProfileChanges = this.profile.address != event.detail.value;
                this.profile.address = event.detail.value;
            }
        };
        this.updateEmail = (event) => {
            if (event) {
                this.hasProfileChanges = this.profile.email != event.detail.value;
                this.profile.email = event.detail.value;
                this.validations.isEmailValid = this.isEmailEmptyOrValid(this.profile.email);
            }
        };
        this.updateWebsite = (event) => {
            if (event && this.profile) {
                this.profile.webSites = [];
                this.$timeout(() => {
                    this.validations.isWebsiteValid = true;
                });
                if (event.detail.data.length > 2) {
                    event.detail.data.pop();
                }
                this.hasProfileChanges = !event.detail.data.length;
                event.detail.data.forEach(site => {
                    this.hasProfileChanges = !this.profile.webSites.includes(site);
                    this.profile.webSites.push(site);
                    if (!this.isWebsiteEmptyOrValid(site)) {
                        this.$timeout(() => {
                            this.validations.isWebsiteValid = false;
                        });
                    }
                });
            }
        };
        this.updateAbout = (event) => {
            if (event) {
                this.hasProfileChanges = this.profile.about != event.detail.value;
                this.profile.about = event.detail.value;
            }
        };
        this.updateVertical = (event) => {
            if (event) {
                this.hasProfileChanges = this.profile.vertical != event.detail.value;
                this.$timeout(() => {
                    this.profile.vertical = event.detail.value;
                });
            }
        };
        this.validateFileType = (filename) => {
            return profilePictureMediaTypes.includes(`${filename.split('.').pop()}`);
        };
        this.updateProfilePicture = async (event) => {
            try {
                this.LoadingService.startLoading();
                if (event) {
                    const file = event.detail.value[0];
                    if (!file) {
                        return;
                    }
                    this.pictureToUpload = file;
                    const mediaUri = await this.ApplicationService2.uploadFile(file, { profile: this.MEDIA_PROFILE_FOR_AVATARS });
                    this.oldPictureUri = this.deepCopyString(this.profile.photoUri);
                    this.profile.photoUri = this.deepCopyString(mediaUri);
                    this.hasPictureChanges = true;
                }
            }
            catch (error) {
                console.error(error);
            }
            finally {
                this.LoadingService.stopLoading();
            }
        };
        this.removeProfilePicture = async () => {
            this.resetPictureChanges();
            this.profile.photoUri = this.deepCopyString(this.oldPictureUri);
        };
        this.createTrackingCloseSuccessModal = () => {
            const defaultPayload = this.createDefaultPayload();
            this.WhatsAppService.createTrackingFlow(this.application, CHANNEL_CONNECTION_WHATSAPP_ACTIVATION_FLOW_MODAL_SUCCESS_CLOSED, defaultPayload);
        };
        this.createDefaultPayload = (success, errorCode, errorDescription) => {
            const defaultPayload = {
                isCloudApiEnabled: this.isCloudApiEnabled,
                currentActivationStep: WhatsAppStepsEnum[this.currentActivationStep],
                success,
                errorCode,
                errorDescription,
                isChannelActive: this.isActive,
            };
            return defaultPayload;
        };
        this.OnSwitchChangeReplyButton = async (event) => {
            this.$timeout(async () => {
                if (event.detail.checked === this.isReplyButtonEnabled) {
                    return;
                }
                const configuration = {
                    IsReplyButtonEnabled: event.detail.checked ? 'True' : 'False',
                };
                const trackingConfiguration = {
                    isCloudApiEnabled: this.isCloudApiEnabled,
                };
                const changed = await this.WhatsAppService.
                    saveConfigurationComponentAndCreateTracking(this.application, event, CHANNEL_CONFIGURATION_WHATSAPP_QUICK_REPLY_SWITCH_CLICKED, configuration, trackingConfiguration);
                if (changed) {
                    this.isReplyButtonEnabled = event.detail.checked;
                }
                else {
                    this.changeSwitchReplyElementValue(!event.detail.checked);
                }
            }, 300);
        };
        this.OnSwitchChangeMenu = async (event) => {
            this.$timeout(async () => {
                if (event.detail.checked === this.isListMessageEnabled) {
                    return;
                }
                const configuration = {
                    IsListMessageEnabled: event.detail.checked ? 'True' : 'False',
                };
                const trackingConfiguration = {
                    isCloudApiEnabled: this.isCloudApiEnabled,
                };
                const changed = await this.WhatsAppService.
                    saveConfigurationComponentAndCreateTracking(this.application, event, CHANNEL_CONFIGURATION_WHATSAPP_MENU_SWITCH_CLICKED, configuration, trackingConfiguration);
                if (changed) {
                    this.isListMessageEnabled = event.detail.checked;
                }
                else {
                    this.changeSwitchMenuElementValue(!event.detail.checked);
                }
            }, 300);
        };
        this.onSwitchChangeAuthMedia = async (event) => {
            this.$timeout(async () => {
                if (event.detail.checked === this.isAuthenticatedMedia) {
                    return;
                }
                const configuration = {
                    IsAuthenticatedMedia: event.detail.checked ? 'True' : 'False',
                };
                const trackingConfiguration = {
                    isAuthenticatedMedia: this.isAuthenticatedMedia,
                };
                const changed = await this.WhatsAppService.
                    saveConfigurationComponentAndCreateTracking(this.application, event, CHANNEL_CONFIGURATION_WHATSAPP_AUTH_MEDIA_SWITCH_CLICKED, configuration, trackingConfiguration);
                if (changed) {
                    this.isAuthenticatedMedia = event.detail.checked;
                }
                else {
                    this.changeSwitchAuthMediaElementValue(!event.detail.checked);
                }
            }, 300);
        };
        this.trackDocumentationQuickReply = () => {
            const defaultPayload = this.createDefaultPayload();
            this.WhatsAppService.
                createTrackingFlow(this.application, CHANNEL_CONFIGURATION_WHATSAPP_QUICK_REPLY_DOCUMENTATION_CLICKED, defaultPayload);
        };
        this.trackDocumentationMenu = () => {
            const defaultPayload = this.createDefaultPayload();
            this.WhatsAppService.
                createTrackingFlow(this.application, CHANNEL_CONFIGURATION_WHATSAPP_MENU_DOCUMENTATION_CLICKED, defaultPayload);
        };
        this.onTabItemClicked = () => {
            const defaultPayload = this.createDefaultPayload();
            this.WhatsAppService.
                createTrackingFlow(this.application, CHANNEL_CONFIGURATION_WHATSAPP_TAB_ITEM_CONFIGURATIONS_CLICKED, defaultPayload);
        };
        this._init();
        // Ensure $onDestroy() is called when scope is destroyed
        if (this.$scope) {
            this.$scope.$on('$destroy', () => {
                if (typeof this.$onDestroy === 'function') {
                    this.$onDestroy();
                }
            });
        }
    }
    async _init() {
        try {
            this.LoadingService.startLoading();
            await super.$onInit();
            this.application.channels = await this.ChannelsService.getChannel(ChannelsNames.WhatsApp, this.isConfigurationsApplicationsDomainUsageGetEnabled);
            this.language = this.mapLanguage(this.TranslateService.getCurrentLanguage());
            this.verticalOptions = await this.createWhatsAppVerticalsOptions();
            await this.ChannelsService.setChannelsDeploymentStatuses();
            await this.setCurrentActivationStep();
            this.subsidiary = await this.ChannelsService.getSubsidiary(ChannelsNames.WhatsApp);
            this.isReplyButtonEnabled = this.getIsReplyButtonEnabled();
            this.changeSwitchReplyElementValue(this.isReplyButtonEnabled);
            this.isListMessageEnabled = this.getIsListMessageEnabled();
            this.changeSwitchMenuElementValue(this.isListMessageEnabled);
            this.isAuthenticatedMedia = this.getIsAuthenticatedMediaEnabled();
            this.changeSwitchAuthMediaElementValue(this.isAuthenticatedMedia);
            this.isCloudApiEnabled = this.getIsCloudApiEnabled();
            this.isWhatsAppStatusCompanyInformationHidden = await ChannelsFeatures.isWhatsAppHideStatusInformationEnabled();
            this.isWhatsAppCoexistenceEnabledConfiguration = this.getIsCoexistenceEnabled();
            this.isWhatsAppCoexistenceEnabled = await ChannelsFeatures.isWhatsAppCoexistenceEnabled();
            this.isOnPremiseEnabled = await ChannelsFeatures.IsWhatsAppOnPremiseEnabled();
            this.isWhatsappAuthenticatedMediaEnabled = await ChannelsFeatures.isWhatsappAuthenticatedMediaEnabled();
            await this.initializeTypeExtrasConfigurationEmbedSignup();
            const { AppId, GraphApiVersion } = await this.loadApplicationInformation();
            this.graphApiVersion = GraphApiVersion;
            this.appId = AppId;
            if (this.isWhatsAppCoexistenceEnabledConfiguration) {
                this.openBanner = JSON.parse(localStorage.getItem(bannerIsVisible));
                if (this.openBanner === null) {
                    this.showBanner = true;
                }
                else {
                    this.showBanner = Boolean(JSON.parse(this.openBanner));
                }
            }
            if (this.currentActivationStep === WhatsAppStepsEnum.VERIFIED) {
                await this.getProfile();
            }
            if (this.currentActivationStep === WhatsAppStepsEnum.AWAIT_CONTAINER) {
                await this.startSubscribeToMessagingEvents();
            }
            this.loaded = true;
        }
        catch (error) {
            this.loaded = false;
            this.BlipToastService.show('danger', {
                msg: error,
            });
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async initializeTypeExtrasConfigurationEmbedSignup() {
        const configEmbedSigup = {
            feature: 'whatsapp_embedded_signup',
        };
        if (this.isWhatsAppCoexistenceEnabled) {
            configEmbedSigup.featureType = 'coexistence';
            configEmbedSigup.sessionInfoVersion = '3';
        }
        function buildExtraConfiguration(configEmbedSigup) {
            const configs = [`feature: '${configEmbedSigup.feature}'`];
            if (configEmbedSigup.featureType) {
                configs.push(`featureType: '${configEmbedSigup.featureType}'`);
            }
            if (configEmbedSigup.sessionInfoVersion) {
                configs.push(`sessionInfoVersion: '${configEmbedSigup.sessionInfoVersion}'`);
            }
            return `{${configs.join(', ')}}`;
        }
        this.extrasEmbedSignup = buildExtraConfiguration(configEmbedSigup);
    }
    async loadApplicationInformation() {
        const result = await this.ChannelsService.getFacebookAppInformation(ChannelsNames.WhatsApp, this.subsidiary);
        return result;
    }
    getIsReplyButtonEnabled() {
        return this.channel.configurations.IsReplyButtonEnabled === 'True';
    }
    getIsListMessageEnabled() {
        return this.channel.configurations.IsListMessageEnabled === 'True';
    }
    getIsAuthenticatedMediaEnabled() {
        return this.channel.configurations.IsAuthenticatedMedia === 'True';
    }
    getIsCloudApiEnabled() {
        return this.channel.configurations.IsCloudApiEnabled === 'True';
    }
    getIsCoexistenceEnabled() {
        return this.channel.configurations.IsCoexistenceEnabled === 'True';
    }
    async getProfile() {
        try {
            this.profile = await this.WhatsAppService.getProfile();
            this.oldPictureUri = this.deepCopyString(this.profile.photoUri);
        }
        catch (err) {
            console.error(err);
            this.BlipToastService.show('danger', {
                msg: err.description,
            });
        }
    }
    handlePreviousStep() {
        if (this.currentActivationStep === WhatsAppStepsEnum.LOGIN) {
            return;
        }
        const defaultPayload = this.createDefaultPayload();
        this.WhatsAppService.createTrackingFlow(this.application, CHANNEL_CONNECTION_WHATSAPP_ACTIVATION_BACK_BUTTON_CLICKED, defaultPayload);
        this.currentActivationStep = WhatsAppStepsEnum.LOGIN;
    }
    handleNextStep() {
        if (this.currentActivationStep === WhatsAppStepsEnum.FACEBOOK_CONNECTION) {
            return;
        }
        const defaultPayload = this.createDefaultPayload();
        this.WhatsAppService.createTrackingFlow(this.application, CHANNEL_CONNECTION_WHATSAPP_ACTIVATION_FLOW_STARTED, defaultPayload);
        this.currentActivationStep = WhatsAppStepsEnum.FACEBOOK_CONNECTION;
    }
    stepCannotSignUp() {
        const cannotSignUp = this.currentActivationStep !== WhatsAppStepsEnum.LOGIN &&
            this.currentActivationStep !== WhatsAppStepsEnum.SELECT_PHONE &&
            this.currentActivationStep !== WhatsAppStepsEnum.PHONE_NOT_FOUND &&
            this.currentActivationStep !== WhatsAppStepsEnum.FACEBOOK_CONNECTION;
        return cannotSignUp;
    }
    openEmbedSignup() {
        const cannotSignUp = this.stepCannotSignUp();
        if (cannotSignUp) {
            return;
        }
        this.createTrackingOpenEmbedSignup();
        clearInterval(this.timerId);
        const extras = this.extrasEmbedSignup;
        const [state, tab] = this.FacebookLoginPopupService.openFacebookLoginPopup(this.appId, this.graphApiVersion, this.WHATSAPP_AUTH_PERMISSIONS, extras);
        const timeToStopPoolingFacebookCookie = new Date(new Date().getTime() + this.FACEBOOK_POPUP_CONNECTION_TIME);
        const timerId = setInterval(() => {
            if (this.$cookies.getObject(state)) {
                const { accessToken } = this.$cookies.getObject(state);
                clearInterval(timerId);
                this.onEmbedSignupSuccessFinished(accessToken);
                return;
            }
            const intervalCannotSignUp = this.stepCannotSignUp();
            if (new Date() > timeToStopPoolingFacebookCookie || intervalCannotSignUp || tab.closed) {
                clearInterval(timerId);
            }
        }, 2000);
    }
    async setContainerConfigurations() {
        this.LoadingService.startLoading();
        const waba = this.wabas.find((waba) => waba.phoneNumbers && waba.phoneNumbers.find((phoneNumber) => phoneNumber.id == this.phoneNumberSelected));
        const user = await this.AccountService2.me();
        try {
            await this.WhatsAppService.setStateConfigurations(this.phoneNumberSelected, waba.id, user.email, this.pinInputed, this.subsidiary, this.skipValidateTicket || this.isWhatsAppCoexistenceEnabled, this.isWhatsAppCoexistenceEnabled, !this.isOnPremiseEnabled);
            await this.startSubscribeToMessagingEvents();
            if (this.isOnPremiseEnabled) {
                this.openStepAwaitContainer();
            }
            else {
                await this.getProfile();
                this.currentActivationStep = WhatsAppStepsEnum.VERIFIED;
            }
            this.createTrackingActivateNumber(true);
        }
        catch (err) {
            if (err.code === 21 && err.description.includes('is already subscribed in other apps')) {
                this.currentActivationStep = WhatsAppStepsEnum.WABA_WITH_ACTIVE_NUMBER_IN_ANOTHER_CONTRACT;
            }
            if (err.code === 64 && err.description.includes('is being used by another caller.')) {
                this.BlipToastService.show('danger', {
                    title: await this.$translate('whatsapp.errorMsg.phoneNumberIsAlreadyConnected.title'),
                    msg: await this.$translate('whatsapp.errorMsg.phoneNumberIsAlreadyConnected.msg'),
                });
            }
            else {
                this.BlipToastService.show('danger', {
                    msg: await this.$translate('whatsapp.errorMsg.validatePhoneNumber.msg') + '</br>' + err.description,
                });
            }
            this.createTrackingActivateNumber(false, err.code, err.description || err);
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async submitProfilePicture() {
        this.LoadingService.startLoading();
        try {
            if (!this.pictureToUpload || !this.profile.photoUri) {
                return;
            }
            if (!this.validateFileType(this.pictureToUpload.name)) {
                throw `Invalid file type. Please upload a file with the following extensions: ${profilePictureMediaTypes.join(', ')}`;
            }
            const profileWithPicutre = {
                photoUri: this.deepCopyString(this.profile.photoUri),
                displayName: undefined,
                address: undefined,
                email: undefined,
                description: undefined,
                webSites: undefined,
                vertical: undefined,
                about: undefined,
                photoMediaType: undefined,
                displayPhoneNumber: undefined,
            };
            await this.WhatsAppService.setProfile(profileWithPicutre);
            const message = await this.$translate('whatsapp.overview.companyInformation.configuration.messages.pictureUpdate.success');
            this.BlipToastService.show('success', {
                msg: message,
            });
            this.resetPictureChanges();
            this.oldPictureUri = this.deepCopyString(this.profile.photoUri);
        }
        catch (err) {
            console.error(err);
            const messageBase = await this.$translate('whatsapp.overview.companyInformation.configuration.messages.pictureUpdate.error');
            this.BlipToastService.show('danger', {
                msg: messageBase,
            });
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async submitProfile() {
        this.LoadingService.startLoading();
        try {
            const profileToUpdate = {
                ...this.profile,
                photoUri: undefined,
            };
            await this.WhatsAppService.setProfile(profileToUpdate);
            const message = await this.$translate('whatsapp.overview.companyInformation.successMsg.informationSaved');
            this.BlipToastService.show('success', {
                msg: message,
            });
            this.hasProfileChanges = false;
        }
        catch (err) {
            console.error(err);
            const messageBase = await this.$translate('whatsapp.overview.companyInformation.errorMsg.errorHasOccurred');
            this.BlipToastService.show('danger', {
                title: messageBase,
                msg: err.description,
            });
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    isActiveNumberTypeButtonVisible(descriptionTypeButton) {
        const isHandleButton = descriptionTypeButton == 'activeNumberHandleButton';
        if (this.isWhatsAppCoexistenceEnabled) {
            return isHandleButton ? Boolean(this.phoneNumberSelected) : !this.phoneNumberSelected;
        }
        const isActiveNumberHandleButtonVisible = this.phoneNumberSelected && this.pinInputed && this.isPinValid;
        const isActiveNumberDisableButtonVisible = !this.phoneNumberSelected || !this.pinInputed || !this.isPinValid;
        return isHandleButton ? isActiveNumberHandleButtonVisible : isActiveNumberDisableButtonVisible;
    }
    isWebsiteEmptyOrValid(website) {
        if (!website) {
            return true;
        }
        return this.isWebSite(website);
    }
    isEmailEmptyOrValid(email) {
        if (!email) {
            return true;
        }
        return this.isEmail(email);
    }
    isWebSite(website) {
        const urlPattern = /(http|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/;
        return urlPattern.test(website.toLowerCase());
    }
    isEmail(email) {
        const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return emailPattern.test(email.toLowerCase());
    }
    async onEmbedSignupSuccessFinished(accessToken) {
        this.LoadingService.startLoading();
        try {
            if (accessToken) {
                await this.getWabaPhoneNumbers(accessToken);
                this.createTrackingEmbedSignup(true);
            }
            else {
                this.resetPage();
            }
        }
        catch (error) {
            this.BlipToastService.show('danger', {
                title: await this.$translate('whatsapp.errorMsg.channelActivation.title'),
                msg: error,
            });
            this.createTrackingEmbedSignup(false, error.code, error.description || error);
            this.resetPage();
        }
        this.LoadingService.stopLoading();
    }
    resetPage() {
        this.currentActivationStep = WhatsAppStepsEnum.LOGIN;
    }
    backToFacebookConnectionStep() {
        this.currentActivationStep = this.whatsAppStepsEnum.FACEBOOK_CONNECTION;
        this.phoneNumberSelected = undefined;
        this.pinInputed = undefined;
        this.createTrackingOpenEmbedSignup();
    }
    async getWabaPhoneNumbers(accessToken) {
        this.phoneNumbersForActivation = [];
        this.wabas = await this.WhatsAppService.getWabas(accessToken);
        this.createPhoneNumberForActivation();
        if (this.phoneNumbersForActivation.length <= 0) {
            this.openStepPhoneNotFound();
            return;
        }
        this.openStepSelectPhone();
    }
    createPhoneNumberForActivation() {
        const phoneNumbers = this.wabas.map((waba) => waba.phoneNumbers).reduce((a, b) => a.concat(b), []);
        phoneNumbers.forEach(phoneNumber => {
            if (phoneNumber.isReadyForActivation || this.isWhatsAppCoexistenceEnabled) {
                const phoneNumberSelected = { label: phoneNumber.number, value: phoneNumber.id };
                this.phoneNumbersForActivation.push(phoneNumberSelected);
            }
        });
    }
    async setCurrentActivationStep() {
        const clientHasBalanceToConnectToWhatsapp = await this.WhatsAppService.clientHasBalanceToConnectToWhatsapp();
        this.skipValidateTicket = await ChannelsFeatures.isWhatsAppSkipValidateTicketEnable();
        if (!this.isActive) {
            if (this.channel.configurations.PhoneNumberId == undefined &&
                !clientHasBalanceToConnectToWhatsapp &&
                !this.skipValidateTicket &&
                !this.isWhatsAppCoexistenceEnabled) {
                this.currentActivationStep = WhatsAppStepsEnum.NOT_POSSIBLE_TO_CONNECT_DUE_NUMBERS_BALANCE;
                return;
            }
            if (this.channel.configurations.PhoneNumberId === undefined) {
                this.currentActivationStep = WhatsAppStepsEnum.LOGIN;
                return;
            }
            if (this.channel.configurations.IsPinInvalid === 'True') {
                this.currentActivationStep = WhatsAppStepsEnum.ASK_PIN;
                return;
            }
            if (this.channel.configurations.PhoneNumberId !== undefined) {
                this.currentActivationStep = WhatsAppStepsEnum.AWAIT_CONTAINER;
                return;
            }
        }
        if (this.isActive) {
            this.currentActivationStep = WhatsAppStepsEnum.VERIFIED;
            return;
        }
        this.currentActivationStep = WhatsAppStepsEnum.AWAIT_CONTAINER;
    }
    openWhatsApp() {
        const phoneNumber = this.channel.configurations.PhoneNumber
            ? `${this.channel.configurations.CountryCode}${this.channel.configurations.PhoneNumber}`
            : this.profile?.displayPhoneNumber?.replace(/\D/g, '');
        this.$window.open(`https://wa.me/${phoneNumber || ''}`, '_blank', 'noopener noreferrer');
    }
    async openDocumentation() {
        const documentationLink = await this.$translate('whatsapp.documentationLink');
        this.$window.open(documentationLink, '_blank', 'noopener noreferrer');
        const defaultPayload = this.createDefaultPayload();
        this.WhatsAppService.createTrackingFlow(this.application, CHANNEL_CONNECTION_WHATSAPP_DOCUMENTATION_LINK_CLICKED, defaultPayload);
    }
    openBusinessAccount() {
        if (this.channel.configurations.BusinessId == undefined) {
            this.$window.open('https://business.facebook.com/settings/security', '_blank', 'noopener noreferrer');
        }
        else {
            this.$window.open(`https://business.facebook.com/settings/security/?business_id=${this.channel.configurations.BusinessId}`, '_blank', 'noopener noreferrer');
        }
    }
    async subscribeToMessagingEvents() {
        this.MessagingHubService.addCommandReceiver(true, (command) => {
            this.filterAndTreatCommand(command);
        });
        await this.WhatsAppService.subscribeToContainerConfiguration();
    }
    filterAndTreatCommand(command) {
        if (!command || command.method === 'get') {
            return;
        }
        if (command.type === 'application/vnd.iris.gateway-event+json') {
            if (!command.resource) {
                return;
            }
            const success = command.resource.payload.success;
            if (success) {
                this.currentActivationStep = WhatsAppStepsEnum.VERIFIED;
            }
        }
    }
    openStepAwaitContainer() {
        this.currentActivationStep = WhatsAppStepsEnum.AWAIT_CONTAINER;
    }
    openStepSelectPhone() {
        const defaultPayload = this.createDefaultPayload();
        this.currentActivationStep = WhatsAppStepsEnum.SELECT_PHONE;
        this.WhatsAppService.createTrackingFlow(this.application, CHANNEL_CONNECTION_WHATSAPP_ACTIVATION_FLOW_SELECTED_PHONE, defaultPayload);
    }
    openStepPhoneNotFound() {
        const defaultPayload = this.createDefaultPayload();
        this.currentActivationStep = WhatsAppStepsEnum.PHONE_NOT_FOUND;
        this.WhatsAppService.createTrackingFlow(this.application, CHANNEL_CONNECTION_WHATSAPP_ACTIVATION_FLOW_PHONE_NOT_FOUND, defaultPayload);
    }
    createTrackingOpenEmbedSignup() {
        const defaultPayload = this.createDefaultPayload();
        if (this.currentActivationStep === WhatsAppStepsEnum.LOGIN || this.currentActivationStep === WhatsAppStepsEnum.FACEBOOK_CONNECTION) {
            this.WhatsAppService.createTrackingFlow(this.application, CHANNEL_CONNECTION_WHATSAPP_ACTIVATION_FLOW_STARTED, defaultPayload);
        }
        if (this.currentActivationStep === WhatsAppStepsEnum.SELECT_PHONE) {
            this.WhatsAppService.createTrackingFlow(this.application, CHANNEL_CONNECTION_WHATSAPP_ACTIVATION_FLOW_SELECTED_PHONE_OPEN_EMBED_SIGNUP, defaultPayload);
        }
        if (this.currentActivationStep === WhatsAppStepsEnum.PHONE_NOT_FOUND) {
            this.WhatsAppService.createTrackingFlow(this.application, CHANNEL_CONNECTION_WHATSAPP_ACTIVATION_FLOW_PHONE_NOT_FOUND_OPEN_EMBED_SIGNUP, defaultPayload);
        }
    }
    createTrackingEmbedSignup(success, errorCode, errorDescription) {
        const defaultPayload = this.createDefaultPayload(success, errorCode, errorDescription);
        this.WhatsAppService.createTrackingFlow(this.application, CHANNEL_CONNECTION_WHATSAPP_ACTIVATION_FLOW_EMBEDDED, defaultPayload);
    }
    createTrackingActivateNumber(success, errorCode, errorDescription) {
        const defaultPayload = this.createDefaultPayload(success, errorCode, errorDescription);
        this.WhatsAppService.createTrackingFlow(this.application, CHANNEL_CONNECTION_WHATSAPP_ACTIVATION_FLOW_ACTIVATE_NUMBER, defaultPayload);
    }
    async startSubscribeToMessagingEvents() {
        try {
            await this.subscribeToMessagingEvents();
        }
        catch (e) {
            console.error(e);
        }
    }
    getSwitchReplyElement() {
        return document.getElementById('switchReplyButton');
    }
    getSwitchMenuElement() {
        return document.getElementById('switchMenu');
    }
    getSwitchAuthMediaElement() {
        return document.getElementById('switchAuthMedia');
    }
    changeSwitchReplyElementValue(checked) {
        const element = this.getSwitchReplyElement();
        if (element) {
            element.checked = checked;
        }
    }
    changeSwitchMenuElementValue(checked) {
        const element = this.getSwitchMenuElement();
        if (element) {
            element.checked = checked;
        }
    }
    changeSwitchAuthMediaElementValue(checked) {
        const element = this.getSwitchAuthMediaElement();
        if (element) {
            element.checked = checked;
        }
    }
    closeBanner() {
        localStorage.setItem(bannerIsVisible, 'false');
    }
    mapLanguage(language) {
        return languages[language] || 'pt_BR';
    }
    async createWhatsAppVerticalsOptions() {
        const options = [];
        for (const value of whatsAppVerticals) {
            const label = await this.$translate(`whatsapp.businessVerticals.${value}`);
            options.push({
                label,
                value,
            });
        }
        return options;
    }
    $onDestroy() {
        // Clean up command receivers to prevent memory leaks
        this.MessagingHubService.clearCommandReceivers();
    }
    deepCopyString(oldString) {
        if (!oldString) {
            return oldString;
        }
        const newString = (' ' + oldString).slice(1);
        return newString;
    }
    resetPictureChanges() {
        this.hasPictureChanges = false;
        this.pictureToUpload = undefined;
    }
}
WhatsAppController.$inject = ['$window', 'application', '$scope', '$translate', 'BlipToastService', 'ApplicationService2', 'ChannelsService', 'LoadingService', 'MessagingHubService', 'WhatsAppService', 'AccountService2', '$timeout', 'FacebookLoginPopupService', 'WHATSAPP_AUTH_PERMISSIONS', 'FACEBOOK_POPUP_CONNECTION_TIME', '$cookies', 'TranslateService', 'MEDIA_PROFILE_FOR_AVATARS'];
